import { render, staticRenderFns } from "./JobsView.vue?vue&type=template&id=25fb8b52&scoped=true&"
import script from "./JobsView.vue?vue&type=script&lang=js&"
export * from "./JobsView.vue?vue&type=script&lang=js&"
import style0 from "./JobsView.vue?vue&type=style&index=0&id=25fb8b52&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fb8b52",
  null
  
)

export default component.exports